// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__nWlVl","label":"LabeledBox_label__1GaO2"};